import {
  CHANGES_MADE,
  CLEAR_CHANGES,
  INVALID_VARIABLES,
  CHANGE_VARIABLE_ORDER,
  CHANGE_MODIFIER_ORDER,
  CHANGE_INSTANCE_ORDER,
  CLEAR_SCHEMA,
  CLEAR_ITEM,
  CREATE_VARIABLE,
  CREATE_DATASOURCE,
  EDIT_DATASOURCE,
  CLEAR_EDIT_DATASOURCE,
  UPDATE_DATA_SOURCE,
  DELETE_DATA_SOURCE,
  UPDATE_DATA_SOURCE_NAME,
  GENERATE_GETTER,
  GENERATE_OPERATOR,
  CLONE_VARIABLE,
  DELETE_VARIABLE,
  HIDE_NAME_FIELD,
  STORE_ITEM,
  STORE_SCHEMA,
  UPDATE_ITEM,
  UPDATE_OPTIONS_ORDER,
  UPDATE_MATCH_ORDER,
  UPDATE_ITEM_CODE,
  UPDATE_ITEM_NAME,
  UPDATE_VARIABLE,
  UPDATE_VARIABLE_MACRO,
  UPDATE_VARIABLE_MODIFIER,
  UPDATE_VARIABLE_INSTANCE,
  UPDATE_VAR_NAME_MAP
} from '../actions/types'

const itemReducer = function (state = {
  hideNameField: false,
  editingDataSource: '',
  changes: false,
  dataSources: {},
  varNameMap: {},
  invalidVariables: []
}, action) {
  switch (action.type) {
    case STORE_SCHEMA:
      return {
        ...state,
        schema: action.schema
      }
    case CLEAR_SCHEMA:
      return {
        ...state,
        schema: false
      }
    case UPDATE_ITEM_CODE:
      return {
        ...state,
        code: action.code
      }
    case HIDE_NAME_FIELD:
      return {
        ...state,
        hideNameField: true
      }
    case STORE_ITEM:
      return {
        ...state,
        ...action.itemData
      }
    case UPDATE_VAR_NAME_MAP:
      return {
        ...state,
        varNameMap: action.varNameMap
      }
    case CLEAR_ITEM:
      return { }
    case UPDATE_ITEM_NAME:
      return {
        ...state,
        name: action.name
      }
    case UPDATE_ITEM:
      return {
        ...state,
        data: { ...state.data, [action.key]: action.value },
        changes: true
      }
    case UPDATE_OPTIONS_ORDER: {
      const { newIdx, oldIdx, updatedOption } = action
      const updatedOptionOrder = [...state.data.options]
      updatedOptionOrder.splice(oldIdx, 1)
      updatedOptionOrder.splice(newIdx, 0, updatedOption)
      return {
        ...state,
        data: {
          ...state.data,
          options: updatedOptionOrder
        }
      }
    }
    case UPDATE_MATCH_ORDER: {
      const { newIdx, oldIdx, updatedMatch } = action
      const updatedMatchOrder = [...state.data.matches]
      updatedMatchOrder.splice(oldIdx, 1)
      updatedMatchOrder.splice(newIdx, 0, updatedMatch)
      return {
        ...state,
        data: {
          ...state.data,
          matches: updatedMatchOrder
        }
      }
    }
    case CREATE_VARIABLE:
      return {
        ...state,
        variables: { ...state.variables || {}, [action.varKey]: { macro: action.macroType, args: [], name: action.varName, modifiers: [], instances: {} } },
        variableOrder: [...state.variableOrder || [], action.varKey],
        varNameMap: { ...state.varNameMap, [action.varKey]: action.varName },
        changes: true
      }
    case CREATE_DATASOURCE:
      return {
        ...state,
        dataSources: { ...state.dataSources, [action.id]: { id: action.id, name: action.name, description: action.description, data: action.data, modifiedAt: action.modifiedAt, columns: action.columns } },
        changes: true
      }
    case EDIT_DATASOURCE:
      return {
        ...state,
        editingDataSource: action.name
      }
    case CLEAR_EDIT_DATASOURCE:
      return {
        ...state,
        editingDataSource: ''
      }
    case UPDATE_DATA_SOURCE:
      return {
        ...state,
        dataSources: {
          ...state.dataSources,
          [action.id]: {
            ...state.dataSources[action.id],
            data: action.rows,
            columns: action.columns
          }
        },
        changes: true
      }
    case DELETE_DATA_SOURCE: {
      const dataSources = { ...state.dataSources }
      delete dataSources[action.id]
      return {
        ...state,
        dataSources,
        changes: true
      }
    }
    case UPDATE_DATA_SOURCE_NAME:
      return {
        ...state,
        dataSources: {
          ...state.dataSources,
          [action.id]: {
            ...state.dataSources[action.id],
            name: action.name
          }
        }
      }
    case GENERATE_GETTER:
      return {
        ...state,
        variables: { ...state.variables, [action.keyName]: { macro: 'getter', args: [...action.args], name: action.varName } },
        variableOrder: [...state.variableOrder, action.keyName],
        varNameMap: { ...state.varNameMap, [action.keyName]: action.varName },
        changes: true
      }
    case GENERATE_OPERATOR:
      return {
        ...state,
        variables: { ...state.variables, [action.keyName]: { macro: 'operator', args: [...action.args], name: action.varName } },
        variableOrder: [...state.variableOrder, action.keyName],
        varNameMap: { ...state.varNameMap, [action.keyName]: action.varName },
        changes: true
      }
    case CLONE_VARIABLE:
      return {
        ...state,
        variables: { ...state.variables, [action.keyName]: action.clonedObj },
        variableOrder: [...state.variableOrder, action.keyName],
        varNameMap: { ...state.varNameMap, [action.keyName]: action.varName },
        changes: true
      }
    case DELETE_VARIABLE: {
      const variables = { ...state.variables }
      const variableOrder = [...state.variableOrder]
      delete variables[action.varName]
      variableOrder.splice(variableOrder.indexOf(action.varName), 1)
      return {
        ...state,
        variables,
        variableOrder,
        changes: true
      }
    }
    case CHANGES_MADE:
      return {
        ...state,
        changes: true
      }
    case CLEAR_CHANGES:
      return {
        ...state,
        changes: false
      }
    case INVALID_VARIABLES:
      return {
        ...state,
        invalidVariables: action.invalidVariables
      }
    case CHANGE_VARIABLE_ORDER: {
      const { name, newIdx, oldIdx } = action
      const varOrder = [...state.variableOrder]
      varOrder.splice(oldIdx, 1)
      varOrder.splice(newIdx, 0, name)
      return {
        ...state,
        variableOrder: varOrder,
        changes: true
      }
    }
    case CHANGE_MODIFIER_ORDER: {
      const { modifier, newIdx, oldIdx, variable } = action
      const modifierOrder = [...state.variables[variable].modifiers]
      modifierOrder.splice(oldIdx, 1)
      modifierOrder.splice(newIdx, 0, modifier)
      return {
        ...state,
        variables: {
          ...state.variables,
          [variable]: {
            ...state.variables[variable],
            modifiers: modifierOrder
          }
        }
      }
    }
    case CHANGE_INSTANCE_ORDER: {
      const { modifier, newIdx, oldIdx, variable, instanceId } = action
      const instanceOrder = [...state.variables[variable].instances[instanceId]]
      instanceOrder.splice(oldIdx, 1)
      instanceOrder.splice(newIdx, 0, modifier)
      return {
        ...state,
        variables: {
          ...state.variables,
          [variable]: {
            ...state.variables[variable],
            instances: {
              ...state.variables[variable].instances,
              [instanceId]: instanceOrder
            }
          }
        }
      }
    }
    case UPDATE_VARIABLE:
      return {
        ...state,
        variables: {
          ...state.variables,
          [action.keyName]: {
            ...state.variables[action.keyName],
            args: action.args,
            name: action.varName
          }
        },
        varNameMap: { ...state.varNameMap, [action.keyName]: action.varName },
        changes: true
      }
    case UPDATE_VARIABLE_MACRO:
      return {
        ...state,
        variables: {
          ...state.variables,
          [action.varName]: {
            ...state.variables[action.varName],
            macro: action.macro
          }
        }
      }
    case UPDATE_VARIABLE_MODIFIER:
      return {
        ...state,
        variables: {
          ...state.variables,
          [action.varName]: {
            ...state.variables[action.varName],
            modifiers: action.modifiers
          }
        },
        changes: true
      }
    case UPDATE_VARIABLE_INSTANCE:
      return {
        ...state,
        variables: {
          ...state.variables,
          [action.varName]: {
            ...state.variables[action.varName],
            instances: {
              ...state.variables[action.varName].instances,
              [action.instance]: action.modifiers
            }
          }
        },
        changes: true
      }
    default:
      return state
  }
}
export default itemReducer



// WEBPACK FOOTER //
// /app/js/reducers/itemReducer.js